import React, {createContext, useContext, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";

const SidebarStateContext = createContext();

export default function SidebarStateProvider({children}) {
  const [sidebarState, setSidebarState] = useState({
    isReportsOpen: false,
    isCostSettingsOpen: false,
    isIncomeSettingsOpen: false,
    isAccountSettingsOpen: false
  });

  const {pathname} = useLocation();

  useEffect(() => {
    if (pathname.includes('reports/')) {
      setSidebarState(state => ({
        ...state,
        isReportsOpen: true
      }));
    }

    if (pathname.includes('settings/cost')) {
      setSidebarState(state => ({
        ...state,
        isCostSettingsOpen: true
      }));
    }

    if (pathname.includes('settings/income')) {
      setSidebarState(state => ({
        ...state,
        isIncomeSettingsOpen: true
      }));
    }

    if (pathname.includes('settings/account')) {
      setSidebarState(state => ({
        ...state,
        isAccountSettingsOpen: true
      }));
    }
  }, [pathname]);

  return (
    <SidebarStateContext.Provider value={{sidebarState, setSidebarState}}>
      {children}
    </SidebarStateContext.Provider>
  );
}

export function useSidebarState() {
  return useContext(SidebarStateContext);
}
